// スコア計算定数（データ駆動）
// ライン得点テーブル: 連続長 → 得点
export const LINE_SCORE_TABLE: Record<number, number> = {
  2: 1,
  3: 10,
  4: 50,
  5: 1000, // 5連は即勝利 + 1000点
} as const

// クラスタ得点: サイズ N の連結成分 → N² × CLUSTER_MULTIPLIER
export const CLUSTER_MULTIPLIER = 0.5

// 色別スコア倍率（後手コミ）。ゲーム中の全スコア計算に作用し、AI の評価関数にも透過的に反映される
export const SCORE_MULTIPLIER: Record<'black' | 'white', number> = {
  black: 1.0,
  white: 1.10,
}

// 5連達成ボーナス（ライン得点の1000に加えてリザルト表示用）
export const WIN_BONUS = 500

// ハイスコア localStorage キー
export const HIGHSCORE_KEY = 'score_gomoku_highscore'

// CPU思考遅延（ミリ秒）
export const CPU_DELAY_MS = 600

// 先手後手確定演出（intro phase）の表示時間
export const INTRO_DURATION_MS = 1800

// finale phase: 盤面のキラキラ・バウンド演出の継続時間（その後 announce へ遷移）
export const FINALE_ANIMATE_MS = 1400

// finale phase: 「○○の勝ち！」バナーの表示時間（その後 result へ遷移）
export const FINALE_ANNOUNCE_MS = 1500

// 難易度の localStorage キー
export const DIFFICULTY_KEY = 'nawabari_difficulty'

// 後手コミのパーセンテージ表記（UI バッジ用。SCORE_MULTIPLIER から算出）
export const BONUS_PERCENT = Math.round((SCORE_MULTIPLIER.white - 1) * 100)

// 縄張りハイライト: この連長以上でセルを着色
export const TERRITORY_HIGHLIGHT_MIN = 3

// 縄張りのパーソナルカラー（タイル画像の上に重ねる）
// 黒=プレイヤーは深い青、白=CPUは深い赤。暗めに設定してナワバリ感を強調する。
export const TERRITORY_COLORS: Record<'black' | 'white', { r: number; g: number; b: number }> = {
  black: { r: 24, g: 56, b: 140 },
  white: { r: 140, g: 28, b: 36 },
}

// 連長に応じた不透明度（5連は勝利ラインのアニメーションで上書きされる）
export const TERRITORY_OPACITY: Record<number, number> = {
  3: 0.32,
  4: 0.58,
}
